import { useContext } from "react";
import { Container } from "react-bootstrap";
import UserOrders from "../components/UserOrders";
import OrdersAdminView from "../components/OrdersAdminView";
import UserContext from "../context/UserContext";

function Orders() {
  const { user } = useContext(UserContext);

  return (
    <div className="orders-page-wrapper">
      {/* Orders Hero Section */}
      <div
        className={`orders-hero-section ${
          user?.isAdmin ? "admin-theme" : "user-theme"
        }`}
      >
        <Container>
          <div className="text-center py-5">
            <div className="hero-icon-container mx-auto mb-4">
              <i
                className={`fas ${
                  user?.isAdmin ? "fa-clipboard-list" : "fa-receipt"
                } text-white`}
              ></i>
            </div>
            <h1 className="display-4 fw-bold text-white mb-3">
              {user?.isAdmin ? "Order Management" : "My Orders"}
            </h1>
            <p className="lead text-white-50 mb-4">
              {user?.isAdmin
                ? "Manage and track all customer orders efficiently"
                : "Track your orders and purchase history"}
            </p>
            <div className="hero-divider mx-auto"></div>
          </div>
        </Container>
      </div>

      {/* Orders Content */}
      <div className="orders-content-section">
        {user && user.isAdmin ? <OrdersAdminView /> : <UserOrders />}
      </div>

      {/* Enhanced Custom Styles */}
      <style jsx>{`
        .orders-page-wrapper {
          min-height: 100vh;
          background: linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%);
        }

        .orders-hero-section.user-theme {
          background: linear-gradient(135deg, #28a745 0%, #20c997 100%);
        }

        .orders-hero-section.admin-theme {
          background: linear-gradient(135deg, #6f42c1 0%, #495057 100%);
        }

        .orders-hero-section {
          position: relative;
          overflow: hidden;
        }

        .orders-hero-section::before {
          content: "";
          position: absolute;
          top: 0;
          left: 0;
          right: 0;
          bottom: 0;
          background: url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100"><defs><pattern id="ordersPattern" width="25" height="25" patternUnits="userSpaceOnUse"><circle cx="12.5" cy="12.5" r="1" fill="white" opacity="0.1"/><circle cx="6" cy="19" r="0.5" fill="white" opacity="0.15"/><circle cx="19" cy="6" r="0.5" fill="white" opacity="0.15"/></pattern></defs><rect width="100" height="100" fill="url(%23ordersPattern)"/></svg>');
          pointer-events: none;
        }

        .hero-icon-container {
          background: rgba(255, 255, 255, 0.2);
          border-radius: 50%;
          width: 100px;
          height: 100px;
          display: flex;
          align-items: center;
          justify-content: center;
          backdrop-filter: blur(10px);
        }

        .hero-icon-container i {
          font-size: 3rem;
        }

        .hero-divider {
          width: 80px;
          height: 4px;
          background: linear-gradient(90deg, transparent, white, transparent);
          border-radius: 2px;
        }

        .orders-content-section {
          position: relative;
          z-index: 1;
        }

        @media (max-width: 768px) {
          .orders-hero-section .display-4 {
            font-size: 2.5rem;
          }

          .orders-hero-section .py-5 {
            padding: 3rem 0 !important;
          }

          .hero-icon-container {
            width: 80px;
            height: 80px;
          }

          .hero-icon-container i {
            font-size: 2.5rem;
          }
        }
      `}</style>
    </div>
  );
}

export default Orders;
